module.exports = __webpack_public_path__ + "img/tag-big.d6163a07.svg";